import { StripeConnectAccount } from '../../components/BankAccountManager/props';
import { StripeEnv } from '../../util/enums';
import { StripeError } from './errors';
import { vaultRequest } from './request';

const GET_STRIPE_CONNECT_ACCOUNT_QUERY = `
query VaultStripeConnectAccountFetch($stripeConnectAccountId: ID!, $stripeEnv: VaultStripeEnv) {
  response: vaultStripeConnectAccountFetch(
    stripeConnectAccountId: $stripeConnectAccountId
    stripeEnv: $stripeEnv
  )
}
`;
export const getStripeConnectAccount = async (
  stripeConnectAccountId: string,
  stripeEnv: StripeEnv,
): Promise<StripeConnectAccount | null> => {
  const stripeAcctRes = await vaultRequest(GET_STRIPE_CONNECT_ACCOUNT_QUERY, {
    stripeConnectAccountId,
    stripeEnv,
  });

  const stripeAcctJson = await stripeAcctRes.json();
  if (stripeAcctJson.errors && stripeAcctJson.errors.length > 0) {
    throw new StripeError(
      'Could not fetch Stripe Connect Account',
      stripeAcctJson.errors[0],
    );
  }
  return stripeAcctJson?.data?.response;
};
